import axiosInstance, { axiosMultipartFormDataInstance } from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';

const userService = {
    authUser: () => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.USER}/${API_PATH.ME}`);
    },
    setImage: () => {
        return axiosInstance.post(`/${API_VERSION}/${API_PATH.USER}/${API_PATH.IMAGE}`);
    },
    logout: () => {
        return axiosInstance.get(`/${API_PATH.LOGOUT}`);
    },
    updateProfileDetails: (payload) => {
        return axiosMultipartFormDataInstance.post(
            `/${API_VERSION}/${API_PATH.USER}/${API_PATH.PROFILE}`,
            payload
        );
    },
    updatePassword: (payload) => {
        return axiosMultipartFormDataInstance.post(
            `/${API_VERSION}/${API_PATH.USER}/${API_PATH.PASSWORD}`,
            payload
        );
    },
    userLoginActivity: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.USER}/${companyId}/${API_PATH.ACTIVITY}`);
    },
    
};

export default userService;
